export default __webpack_public_path__ + "static/media/all-nft-v-min.6c60b74b.png";